function arrayBufferToUrl(arrayBuffer: ArrayBuffer): string {
    // Get uint array
    const uint = new Uint8Array(arrayBuffer);

    //
    const blob = new Blob([uint]);

    //
    const urlCreator = window.URL || window.webkitURL;
    const url = urlCreator.createObjectURL(blob);

    // Return
    return url;
}

// ----------------------------------------------------------------------------

export default arrayBufferToUrl;
